// extracted by mini-css-extract-plugin
export var externalLink = "_di-0";
export var internalLinkLabel = "_di-1";